/*
 * WARNING: This file is owned by ws-scripts and can not be edited!
 *
 * This is the main entry point for our application when
 * executed in the browser. As such, it has some responsibilities:
 *
 * - Load server side rendered redux state
 * - Create the redux store with that state
 * - Kick off a React render bound to the redux store
 *
 * NOTE: The eslint-disable-lines are needed because this file won't lint
 * when it's in the ws-scripts repo because those files only exist in the
 * widget. It's safe because the entire application won't work if those
 * weren't really resolved. It would be really apparent quickly.
 *
 * We load our server side rendered state from an object
 * of the form:
 *
 *	window.DDC = {
 *		OSIRIS: {
 *			state: {
 *				"ws-hours": {
 *					"hours1": {STATE}
 *					"hours2": {STATE}
 *				},
 *				"ws-quick-specs": {
 *					"quick-specs1": {STATE}
 *				}
 *			}
 *		}
 *	};
 *
 * In local development, the state will be a JSON object. When
 * loaded from CMS, it will be a string, since that reduces
 * serialization overhead but still avoids string concatenation.
 */

import React from 'react';
import { hydrate, render } from 'react-dom';
import { AppContainer } from 'react-hot-loader';

import Widget from '../containers/Widget'; // eslint-disable-line import/no-unresolved
import { createStore } from './store';
import { getWidgetComponents } from './widget-components';

const getWidgetStatesByType = widgetName => {
	if (
		!window.DDC ||
		!window.DDC.OSIRIS ||
		!window.DDC.OSIRIS.state ||
		!window.DDC.OSIRIS.state[widgetName]
	) {
		return {};
	}

	return window.DDC.OSIRIS.state[widgetName];
};

const getWidgetState = (widgetStates, widgetId) => {
	let preloadedState = widgetStates[widgetId];

	if (typeof preloadedState === 'string') {
		preloadedState = JSON.parse(preloadedState);
	}

	return preloadedState;
};

const renderWidget = (WidgetComponent, renderFunc, store, widgetId) => {
	renderFunc(
		<AppContainer>
			{getWidgetComponents(WidgetComponent, store, widgetId)}
		</AppContainer>,
		document.getElementById(`${widgetId}-app-root`)
	);
};

const widgetIdToStore = {};

const initializeWidgets = () => {
	const widgetStates = getWidgetStatesByType('ws-vehicle-media');
	const widgetIds = Object.keys(widgetStates);

	widgetIds.forEach(widgetId => {
		const store = createStore(getWidgetState(widgetStates, widgetId));
		widgetIdToStore[widgetId] = store;
		renderWidget(Widget, hydrate, store, widgetId);
	});
};

if (
	window.DDC &&
	window.DDC.Events &&
	window.DDC.Events['inline-js-available']
) {
	initializeWidgets();
} else {
	$(document).on('inlineJSAvailable', initializeWidgets);
}

if (module.hot) {
	module.hot.accept('../containers/Widget', () => {
		Object.keys(widgetIdToStore).forEach(widgetId => {
			const store = widgetIdToStore[widgetId];
			const ReloadedWidget = require('../containers/Widget').default; // eslint-disable-line import/no-unresolved
			renderWidget(ReloadedWidget, render, store, widgetId);
		});
	});
}



// WEBPACK FOOTER //
// ./src/ws-scripts/browser.jsx